<template>
  <div class="pk-flex pk-carousel-container-wrapper">
    <div style="z-index: 100; position: absolute;height: 100%;">
      <div class="pk-flex__vh-center"
       style="position:relative;height:100%"><img class="pk-svg-prev"
         src="../../assets/icons/previous.svg"
         @click="prev()"></div>
    </div>
    <div style="flex:1; position:relative;">
      <div ref="pk-carousel-container"
       class="pk-carousel-container">
        <Carousel :perPage="perPage"
         :autoplay="true"
         :autoplayTimeout="5000"
         :paginationSize="0"
         :navigationEnabled="true"
         :navigationNextLabel="''"
         :navigationPrevLabel="''">
          <Slide v-for="(img, i) in imageItems"
           :key="i"
           class="text-center">
            <img class=""
             :src="img"
             style="width:100%">
          </Slide>
        </Carousel>
      </div>
    </div>
    <div style="z-index: 100; position: absolute; right:0px; height: 100%;">
      <div class="pk-flex__vh-center pk-flex__00auto"
       style="position:relative;height:100%"><img class="pk-svg-next"
         src="../../assets/icons/next.svg"
         @click="next()"></div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

import Vue from 'vue';
export default Vue.extend({
  props: {
    imageItems: Array
  },
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      //      imageHeight: 400,
      //      imageWidth: 400,
      perPage: 1
    };
  },
  mounted() {
    const ci = this.$refs['pk-carousel-container'];
    const vue = this;

    const setSize = () => {
      vue.imageWidth = ci.clientWidth;
      vue.imageHeight = ci.clientHeight;
    };
    setTimeout(setSize, 350);
    window.addEventListener('resize', setSize);
  },
  computed: {

  },
  methods: {
    prev() {
      const a = document.querySelector('a.VueCarousel-navigation-prev');
      a.click();
    },
    next() {
      const a = document.querySelector('a.VueCarousel-navigation-next');
      a.click();
    }
  }
});
</script>

<style>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';

.pk-carousel-container-wrapper {
  position: relative;
  width: 100%;
}

.pk-carousel-container {
  height: auto;
  width: 100%;
  overflow: hidden;
}

.VueCarousel-dot-container {
  display: none !important;
}

.pk-svg-next,
.pk-svg-prev {
  margin: 20px;
  height: 35px;
  cursor: pointer;
}

.pk-svg-next:hover,
.pk-svg-prev:hover {
  background-color: #fff;
  border-radius: 2px;
}
</style>